module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_16.fd309158.mp3";